import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { BaseWellnessViewComponent } from '../base-wellness-view/base-wellness-view.component';
import { TwoDayCalendarViewComponent } from '../two-day-calendar-view/two-day-calendar-view.component';
import { DragAndDropService } from 'src/app/services/drag-and-drop.service';
import { AuthHelperService } from 'src/app/services/auth-helper.service';

@Component({
    selector: 'app-wellness-day-view',
    templateUrl: './wellness-day-view.component.html',
    styleUrls: ['./wellness-day-view.component.css'],
    standalone: false
})
export class WellnessDayViewComponent extends BaseWellnessViewComponent implements OnInit {
    selectedView = 'day';

    @ViewChild(TwoDayCalendarViewComponent) calendarComponent: TwoDayCalendarViewComponent;

    constructor(
        @Inject(DragAndDropService) dragAndDropService: DragAndDropService,
        @Inject(AuthHelperService) authHelperService: AuthHelperService
    ) {
        super(dragAndDropService, authHelperService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

}
